var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    {
      attrs: { show: _vm.show },
      model: {
        value: _vm.show,
        callback: function($$v) {
          _vm.show = $$v
        },
        expression: "show"
      }
    },
    [
      _c(
        "CabeceraModal",
        {
          attrs: { titulo: "Alta de Servicio " + _vm.data["Número de Alta"] },
          on: { cerrar: _vm.handleShowPopUp }
        },
        [
          _c(
            "div",
            {
              staticClass: "numero_sim",
              staticStyle: {
                "letter-spacing": "0.02em",
                "white-space": "nowrap",
                overflow: "hidden",
                "text-overflow": "ellipsis",
                "margin-top": "16px"
              }
            },
            [
              _c(
                "div",
                { staticStyle: { height: "37px" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "icon",
                      style:
                        "padding-right: 20px; display: block; margin: 0 0 0 auto; " +
                        (!_vm.disabledButtun &&
                          "background-color:#ff6c00 !important; border-color:#ff6c00 !important;"),
                      attrs: { color: "primary", disabled: _vm.disabledButtun },
                      on: { click: _vm.handleEdit }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "color-blanco",
                          staticStyle: { color: "white" }
                        },
                        [_vm._v("Guardar Cambios")]
                      )
                    ]
                  )
                ],
                1
              )
            ]
          )
        ]
      ),
      _c(
        "v-card",
        { attrs: { height: "55px", flat: "" } },
        [
          _c(
            "v-bottom-nav",
            {
              attrs: {
                value: true,
                active: _vm.pasos.informacionGeneral.step,
                absolute: "",
                color: "transparent"
              },
              on: {
                "update:active": function($event) {
                  return _vm.$set(_vm.pasos.informacionGeneral, "step", $event)
                }
              }
            },
            [
              _c(
                "v-btn",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.pasos.informacionGeneral.visible,
                      expression: "pasos.informacionGeneral.visible"
                    }
                  ],
                  attrs: {
                    color: "primary",
                    flat: "",
                    value: _vm.pasos.informacionGeneral.step
                  },
                  on: { click: _vm.handleInfoGeneral }
                },
                [
                  _c("span", [_vm._v("Detalle")]),
                  _c("v-icon", [_vm._v("info")])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showInfo,
              expression: "showInfo"
            }
          ],
          staticClass: "cardnew modal-editar-alta__conecta",
          attrs: { align: "center" }
        },
        [
          _c("br"),
          _c(
            "div",
            { staticClass: "orden_compra", attrs: { align: "center" } },
            [
              _c(
                "v-flex",
                { attrs: { md10: "" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "rounded-card" },
                    [
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          staticClass: "col-md-12",
                          attrs: { "lazy-validation": "" }
                        },
                        [
                          _c(
                            "v-container",
                            { attrs: { "grid-list-md": "" } },
                            [
                              _c(
                                "v-toolbar",
                                [
                                  _c(
                                    "v-tabs",
                                    { attrs: { centered: "" } },
                                    [
                                      _c("v-tabs-slider", {
                                        attrs: { color: "yellow" }
                                      }),
                                      _c("v-tab", [
                                        _c(
                                          "h4",
                                          { staticStyle: { color: "#27488e" } },
                                          [
                                            _vm._v(
                                              "\n                      Editar Campos\n                    "
                                            )
                                          ]
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-tabs-items",
                                [
                                  _c(
                                    "v-tab-item",
                                    [
                                      _c(
                                        "v-card",
                                        { attrs: { flat: "" } },
                                        [
                                          _c(
                                            "FormFieldsContainer",
                                            {
                                              attrs: {
                                                titulo:
                                                  "Editar Alta de Servicio"
                                              }
                                            },
                                            [
                                              _c(
                                                "v-flex",
                                                {
                                                  attrs: {
                                                    xs12: "",
                                                    layout: "",
                                                    wrap: "",
                                                    "mt-1": "",
                                                    "mb-5": ""
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      attrs: {
                                                        sm3: "",
                                                        md3: ""
                                                      }
                                                    },
                                                    [
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          "prepend-icon": "123",
                                                          color: "primary",
                                                          label:
                                                            "Número de Alta",
                                                          disabled: ""
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.data[
                                                              "Número de Alta"
                                                            ],
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.data,
                                                              "Número de Alta",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "data['Número de Alta']"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      attrs: {
                                                        sm3: "",
                                                        md3: ""
                                                      }
                                                    },
                                                    [
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          "prepend-icon":
                                                            "calendar_month",
                                                          color: "primary",
                                                          label:
                                                            "Fecha de Registro",
                                                          disabled: ""
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.data[
                                                              "Fecha de Registro"
                                                            ],
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.data,
                                                              "Fecha de Registro",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "data['Fecha de Registro']"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      attrs: {
                                                        sm3: "",
                                                        md3: ""
                                                      }
                                                    },
                                                    [
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          label:
                                                            "Fecha Instalación",
                                                          "prepend-icon":
                                                            "calendar_month",
                                                          disabled: ""
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.data[
                                                              "Fecha Instalación"
                                                            ],
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.data,
                                                              "Fecha Instalación",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "data['Fecha Instalación']"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      attrs: {
                                                        sm3: "",
                                                        md3: ""
                                                      }
                                                    },
                                                    [
                                                      _c("v-autocomplete", {
                                                        class:
                                                          _vm.inputError
                                                            .coordinador &&
                                                          "red-text__input",
                                                        attrs: {
                                                          items: _vm.excludeInactiveDataInLists(
                                                            {
                                                              list:
                                                                _vm.filtroCoordinador,
                                                              key: "coorbaja"
                                                            }
                                                          ),
                                                          "item-text":
                                                            "coorname",
                                                          "item-value":
                                                            "coorid",
                                                          label:
                                                            "Coordinador (Obligatorio)",
                                                          "prepend-icon":
                                                            "supervisor_account",
                                                          required: "",
                                                          error:
                                                            _vm.inputError
                                                              .coordinador
                                                        },
                                                        on: {
                                                          change:
                                                            _vm.handleChangeEvent
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.objParam.coorid,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.objParam,
                                                              "coorid",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "objParam.coorid"
                                                        }
                                                      }),
                                                      _vm.inputError.coordinador
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "red_error_intput"
                                                            },
                                                            [
                                                              _c("span", [
                                                                _c("strong", [
                                                                  _vm._v("*")
                                                                ]),
                                                                _vm._v(
                                                                  " El campo Coordinador es\n                              obligatorio"
                                                                )
                                                              ])
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      attrs: {
                                                        sm3: "",
                                                        md3: ""
                                                      }
                                                    },
                                                    [
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          label: "Técnico",
                                                          "prepend-icon":
                                                            "supervisor_account",
                                                          disabled: ""
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.data["Técnico"],
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.data,
                                                              "Técnico",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "data['Técnico']"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      attrs: {
                                                        sm3: "",
                                                        md3: ""
                                                      }
                                                    },
                                                    [
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          "prepend-icon": "123",
                                                          label:
                                                            "Número de Orden",
                                                          disabled: ""
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.data[
                                                              "Número Orden"
                                                            ],
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.data,
                                                              "Número Orden",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "data['Número Orden']"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      attrs: {
                                                        sm3: "",
                                                        md3: ""
                                                      }
                                                    },
                                                    [
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          label: "Cliente",
                                                          "prepend-icon":
                                                            "supervisor_account",
                                                          disabled: ""
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.data["Cliente"],
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.data,
                                                              "Cliente",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "data['Cliente']"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      attrs: {
                                                        sm3: "",
                                                        md3: ""
                                                      }
                                                    },
                                                    [
                                                      _c("v-autocomplete", {
                                                        class:
                                                          _vm.inputError
                                                            .flota &&
                                                          "red-text__input",
                                                        attrs: {
                                                          items:
                                                            _vm.filterFlotasApi,
                                                          "item-text":
                                                            "__nom_flota",
                                                          "item-value":
                                                            "cod_flota",
                                                          "prepend-icon":
                                                            "local_shipping",
                                                          label:
                                                            "Flota (Obligatorio)",
                                                          required: "",
                                                          error:
                                                            _vm.inputError
                                                              .flota,
                                                          "no-data-text":
                                                            "No hay flotas disponibles"
                                                        },
                                                        on: {
                                                          change:
                                                            _vm.handleChangeEvent
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.objParam
                                                              .cod_flota,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.objParam,
                                                              "cod_flota",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "objParam.cod_flota"
                                                        }
                                                      }),
                                                      _vm.inputError.flota
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "red_error_intput"
                                                            },
                                                            [
                                                              _c("span", [
                                                                _c("strong", [
                                                                  _vm._v("*")
                                                                ]),
                                                                _vm._v(
                                                                  " El campo Flota es\n                              obligatorio"
                                                                )
                                                              ])
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      attrs: {
                                                        sm3: "",
                                                        md3: ""
                                                      }
                                                    },
                                                    [
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          "prepend-icon":
                                                            "directions_car",
                                                          label: "Patente",
                                                          disabled: ""
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.data["Patente"],
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.data,
                                                              "Patente",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "data['Patente']"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      attrs: {
                                                        sm3: "",
                                                        md3: ""
                                                      }
                                                    },
                                                    [
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          "prepend-icon":
                                                            "directions_car",
                                                          color: "primary",
                                                          label:
                                                            "Marca Vehículo",
                                                          id: "marca",
                                                          disabled: ""
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.data[
                                                              "Marca Vehículo"
                                                            ],
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.data,
                                                              "Marca Vehículo",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "data['Marca Vehículo']"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      attrs: {
                                                        sm3: "",
                                                        md3: ""
                                                      }
                                                    },
                                                    [
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          "prepend-icon":
                                                            "directions_car",
                                                          label:
                                                            "Modelo Vehículo",
                                                          disabled: ""
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.data[
                                                              "Modelo Vehículo"
                                                            ],
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.data,
                                                              "Modelo Vehículo",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "data['Modelo Vehículo']"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      attrs: {
                                                        sm3: "",
                                                        md3: ""
                                                      }
                                                    },
                                                    [
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          type: "number",
                                                          maxlength: "4",
                                                          "prepend-icon":
                                                            "directions_car",
                                                          color: "primary",
                                                          label: "Año Vehículo",
                                                          disabled: ""
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.data[
                                                              "Año Vehículo"
                                                            ],
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.data,
                                                              "Año Vehículo",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "data['Año Vehículo']"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      attrs: {
                                                        sm3: "",
                                                        md3: ""
                                                      }
                                                    },
                                                    [
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          label: "Estado",
                                                          "prepend-icon":
                                                            "block",
                                                          disabled: ""
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.data["Estado"],
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.data,
                                                              "Estado",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "data['Estado']"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogPopUp,
          titulo: _vm.$t("Confirmación"),
          mensaje:
            "Al cerrar esta ventana toda la información editada se perderá. ¿Está seguro que desea cerrar sin guardar?",
          textoBtnSi: _vm.$t("No Guardar"),
          textoBtnNo: _vm.$t("Continuar Editando")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.showPopuP($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }